<template lang="pug">
  .type-intro-mobile(:class="color")
    .description
      h2.f-0 Redaction —
      h2.f-0 a multiplicity of typographic,
      h2.f-0 legal, and human histories
      p.f-0 Redaction is a bespoke typeface commissioned by <a target="_blank" href="https://kapharstudio.com/">Titus Kaphar</a> and <a target="_blank" href="http://www.dwaynebetts.com/">Reginald Dwayne Betts</a>’ <i>The Redaction</i> exhibition at <a target="_blank" href="http://www.dwaynebetts.com/">MoMA PS1</a>. As part of a timely conversation at the intersection of history, the legal system and social justice, the fonts will be free for personal use. In a spirit of generosity, the artists invite everyone to broaden the ethos of the exhibition by making these tools accessible to a global and engaged audience.
</template>

<script>
export default {
  name: "FontIntroMobile",

  props: ["color"]
};
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.type-intro-mobile
  width: 86vw
  margin: auto
  position: relative
  display: block
  margin: 4rem auto
  @media only screen and (min-width: $m)
    display: none
  .description
    h2
      font-size: 2.3rem
      line-height: 2.5rem
      &:nth-child(1)
        font-size: 5rem
        line-height: 5.1rem
    p
      margin-top: 4rem
      font-size: 1.7rem
      line-height: 2.2rem
</style>
